export const QUIZZES_POLLS_APP_NAME = "QuizzesPolls";
